import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
import { transition } from '@helpers/animate';
import { Device, until } from '@helpers/media';
import { fluid } from '@helpers/fluid';
const Container = styled.div `
  --color: ${brand.primary.blue.base};
  display: flex;
  justify-content: center;
  ${transition('opacity', 0.25, 'ease-in-out')}

  &[data-disabled='true'] {
    pointer-events: none;
    opacity: 0.5;
  }

  ul {
    display: flex;
    align-items: center;
    gap: ${fluid(8, 24)};

    @media ${until(Device.Tablet)} {
      flex-wrap: wrap;
    }
  }

  li {
    user-select: none;
  }

  li.previous,
  li.next {
    a > div {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    ${fonts.helveticaNeue.regular};
    font-size: 12px;
    line-height: 14px;
    color: var(--color);
    text-transform: uppercase;
    cursor: pointer;

    ${transition('opacity', 0.25, 'ease-in-out')}

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    @media ${until(Device.Tablet)} {
      div {
        display: flex;
        align-items: center;
        gap: 8px;

        span {
          display: none;
        }
      }
    }
  }

  li.next > a > div > svg {
    transform: rotate(180deg);
  }

  li:not(.previous):not(.next) {
    font-size: 14px;
    line-height: 21px;
    color: var(--color);
    ${fonts.helveticaNeue.regular};
    text-decoration: underline;
    text-decoration-color: transparent;
    text-underline-offset: 6px;
    cursor: pointer;
    ${transition('text-decoration-color', 0.25, 'ease-in-out')}

    &.selected {
      text-decoration-color: var(--color);
    }

    @media ${until(Device.Tablet)} {
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid ${brand.primary.blue.lighter3};
        text-decoration: none;
        width: 32px;
        height: 32px;
      }

      &.selected {
        background-color: var(--color);
        color: ${brand.white};
      }

      &.break {
        border: none;
      }
    }
  }
`;
export const PaginationStyles = {
    Container,
};
